import {
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_OK,
  GET_SUBSCRIPTION_ERR,
  INIT_SETUP_PAYMENT_METHOD,
  INIT_SETUP_PAYMENT_METHOD_OK,
  INIT_SETUP_PAYMENT_METHOD_ERR,
  DO_INIT_SETUP_PAYMENT_METHOD_CLEANUP,

  INIT_INSTANT_PAYMENT_METHOD,
  INIT_INSTANT_PAYMENT_METHOD_OK,
  INIT_INSTANT_PAYMENT_METHOD_ERR,
  DO_INIT_INSTANT_PAYMENT_METHOD_CLEANUP,
} from './actionTypes';

/********** GET SUBSCRIPTION **********/

export const getSubscription = () => ({
  type: GET_SUBSCRIPTION,
});

export const getSubscriptionOk = response => ({
  type: GET_SUBSCRIPTION_OK,
  payload: { response },
});

export const getSubscriptionErr = error => ({
  type: GET_SUBSCRIPTION_ERR,
  payload: { error },
});

/********** COLLECT PAYMENT INFO **********/

export const initSetupPaymentMethod = () => ({
  type: INIT_SETUP_PAYMENT_METHOD,
});

export const initSetupPaymentMethodOk = response => ({
  type: INIT_SETUP_PAYMENT_METHOD_OK,
  payload: { response },
});

export const initSetupPaymentMethodErr = error => ({
  type: INIT_SETUP_PAYMENT_METHOD_ERR,
  payload: { error },
});

export const doInitSetupPaymentMethodCleanup = () => ({
  type: DO_INIT_SETUP_PAYMENT_METHOD_CLEANUP,
});

/********** COLLECT INSTANT PAYMENT INFO **********/

export const initInstantPaymentMethod = (id, data) => ({
  type: INIT_INSTANT_PAYMENT_METHOD,
  payload: { id, data },
});

export const initInstantPaymentMethodOk = response => ({
  type: INIT_INSTANT_PAYMENT_METHOD_OK,
  payload: { response },
});

export const initInstantPaymentMethodErr = error => ({
  type: INIT_INSTANT_PAYMENT_METHOD_ERR,
  payload: { error },
});

export const doInitInstantPaymentMethodCleanup = () => ({
  type: DO_INIT_INSTANT_PAYMENT_METHOD_CLEANUP,
});